import React, { Component } from 'react'
import { connect } from 'react-redux'
import copy from 'fast-copy'
import Checkbox from 'components/input/checkbox'
import DragHandle from 'components/drag-handle/drag-handle'
import EditableInputField from 'components/input/editableInputField'
import { Draggable } from 'react-beautiful-dnd'

import { withRouter } from 'react-router'

import { 
    openModal, 
    updateTodo, 
    deleteTodo,
    updateChecklistItem
} from 'state/actions'

import { 
    isMobile,
    getPrimaryColumnValue
} from 'utils'

class Todo extends Component {
    state = {
        editing: false,
        text: '',
        tempChecked: null,
    }

    milestone = null
    project = null

    componentWillMount = _ => {
        this.setState({
            text: this.props.todo.text
        })
    }

    updateText = text => {
        this.setState({
            text,
        })
    }

    toggleEditing = _ => {
        this.setState({
            editing: !this.state.editing,
            oldTodoName: this.props.todo.text,
        })
    }

    cancelEditing = _ => {
        this.setState({
            editing: !this.state.editing,
            text: this.state.oldTodoName, 
        })
    }

    isTodoChecked = _ => {
        const {
            isChecklist,
            todo,
            task,
            allMilestones,
            allProjects
        } = this.props

        const {
            tempChecked
        } = this.state

        if(!isChecklist){
            let isChecked = false

            if(todo.task_id && task){
                let statusId = null

                const milestone = allMilestones[task.milestone_id]

                if(milestone){
                    const project = allProjects[milestone.project_id]

                    if(project){
                        statusId = getPrimaryColumnValue('status', task, project)
                    }
                }

                if(task && statusId === 3){
                    isChecked = true
                }
            }else{
                isChecked = todo.is_checked
            }

            if(tempChecked !== null && tempChecked !== isChecked){
                return tempChecked
            }

            return isChecked
        }else{
            return (todo.is_checked || tempChecked)
        }
    }

    updateTodo = (todo, action, isNowChecked) => {
        const {
            allMilestones,
            allProjects,
            isDragging,
            updateTask,
            updateTodo,
            updateChecklistItem,
            task,
            isChecklist,
            isToday,
            isDisabled
        } = this.props

        const {
            editing,
            text
        } = this.state

        if(isDragging){
            return
        }
        
        if(!editing || action !== 'checked'){
            if((isToday || isChecklist) && !isDisabled){
                this.setState({
                    tempChecked: isNowChecked
                })

                // taken the next bit out of the if(!todo.task_id). it should check the todo either way.
                let tempTodo = copy(todo)
                
                switch(action){
                    case 'checked':
                        tempTodo.is_checked = isNowChecked
                    break
                    case 'name':
                        if(!todo.task_id || isChecklist){
                            tempTodo.text = text

                            this.setState({
                                editing: false
                            })
                        }
                    break
                }

                if(isChecklist){
                    updateChecklistItem(tempTodo)
                }else{
                    updateTodo(tempTodo)
                    
                    if(todo.task_id){
                        let tempTask = copy(task)

                        const milestone = allMilestones[task.milestone_id]

                        if(milestone){
                            const project = allProjects[milestone.project_id]

                            if(project){
                                let columnId = null
                                
                                project.columns.forEach(column => {
                                    if(column.type == 'STATUS' && column.is_primary){
                                        columnId = column.id
                                    }
                                })

                                if(columnId){
                                    const columnData = tempTask.column_data || {}

                                    if(isNowChecked){
                                        columnData[columnId] = 3
                                    }else{
                                        columnData[columnId] = null
                                    }

                                    tempTask.column_data = columnData
            
                                    updateTask(tempTask)
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    deleteTodo = _ => {
        const {
            openModal,
            todo,
            isChecklist,
        } = this.props

        if(!isChecklist){
            openModal('delete', 'todo', {
                todo
            })
        }else{
            openModal('delete','checklist_item', todo)
        }
    }

    openTask = _ => {
        const {
            match,
            history,
            todo
        } = this.props

        if(!this.project){
            return null 
        }

        const newUrl = match.url+'/projects/'+this.project.slug+'/tasks/'+todo.task_id

        history.push(newUrl)
    }

    render() {
        const {
            todo, 
            isToday, 
            isVisible, 
            index,
            task,
            allMilestones,
            allProjects,
            isChecklist,
            isDisabled,
        } = this.props

        const {
            text
        } = this.state

        let todoText = text

        this.milestone = null
        this.project = null

        const isChecked = this.isTodoChecked()
        
        if(todo.task_id && !isChecklist){
            if(!task){
                return null
            }

            this.milestone = allMilestones[task.milestone_id]
            this.project = this.milestone ? allProjects[this.milestone.project_id] : null

            todoText = task.name
        }

        let className = 'todo-list-item'

        if(!isToday){
            className += 'disabled'
        }

        if(isChecked){
            className += ' checked'
        }

        if(!isVisible){
            className += ' invisible'
        }

        if(this.state.editing) {
            className += ' is-editing'
        }

        if(isChecklist){
            className += ' block-drag-handle-hover'
        }

        return (
            <Draggable 
                isDragDisabled={isMobile()}
                disableInteractiveElementBlocking={!this.state.editing} 
                index={index} 
                key={todo.id} 
                draggableId={'todo-'+todo.id} 
                type="TODO"
            >
                {provided => (
                    <div 
                        className={ !isVisible ? 'invisible' : null } 
                        ref={provided.innerRef}
                        {...provided.draggableProps} 
                        {...provided.dragHandleProps} 
                    >
                        <li 
                            className={className}
                            style={{
                                transitionDelay: (index/15)+'s'
                            }}
                        >
                            <div>
                                <DragHandle />
                                <label className={(!isToday || isDisabled) ? 'no-hover' : null}>
                                    <Checkbox 
                                        isChecked={isChecked} 
                                        onChange={isNowChecked => {this.updateTodo(todo, 'checked', isNowChecked)}} 
                                    />
                                    <i></i>
                                </label>
                                <div onClick={_ => {this.updateTodo(todo, 'checked', !isChecked)}}>
                                    <EditableInputField 
                                        text={todoText} 
                                        updateText={this.updateText} 
                                        saveItem={_ => this.updateTodo(todo, 'name', null)} 
                                        deleteItem={this.deleteTodo} 
                                        isEditing={this.state.editing} 
                                        toggleEditing={this.toggleEditing} 
                                        disableEdits={!!(!isChecklist && task)} 
                                        cancelEditing={this.cancelEditing}
                                        openTask={this.openTask}
                                        hasTask={!!(!isChecklist && task)}
                                        id={todo ? todo.id : 0}
                                        isDisabled={isDisabled}
                                    />
                                    { (task && !isChecklist) ?
                                        <span className="lower-row">
                                            from { (this.milestone && this.project) ? this.project.name+' - '+this.milestone.name : 'a deleted milestone' }
                                        </span>
                                    : null }
                                </div>
                            </div>
                        </li>
                        { provided.placeholder }
                    </div>
                )}
            </Draggable>
        )
    }
}

export default withRouter(connect(null, { 
    openModal, 
    updateTodo, 
    deleteTodo,
    updateChecklistItem
})(Todo))



// WEBPACK FOOTER //
// ./src/layout/header/header-tabs/todo.jsx